<template>
  <div>
    <i-modal :value="isShow" @on-cancel="cancel" width="600px" class-name="vertical-center-modal" footer-hide>
      <div slot="header" class="title">
        <h2>预览</h2>
      </div>
      <div class="content">
        <div v-for="(item, index) in previewData.attributes" :key="index">
          <i-row class="a-row" align="middle" v-if="item.split('__')[1] === 'string'">
            <i-col span="8" offset="1">
              <span class="text">模板变量{{ item.split("__")[2] }}：</span>
            </i-col>
            <i-col span="14">
              <i-input class="col-input" type="text" v-model="templateAttr[item]"></i-input>
            </i-col>
          </i-row>
          <i-row class="a-row" align="middle" v-else-if="item.split('__')[1] === 'file'">
            <i-col span="8" offset="1">
              <span class="text">模板变量{{ item.split("__")[3] }}：</span>
            </i-col>
            <i-col span="14">
              <input
                type="file"
                :accept="item.split('__')[2] === 'picture' ? 'image/*' : 'video/*'"
                @change="changeFile($event, item.split('__')[2], item)"
                :id="item"
              />
            </i-col>
          </i-row>
        </div>
      </div>
    </i-modal>
  </div>
</template>

<script>
export default {
  name: "previewTemplate",
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    previewData: {
      type: Object,
      default() {
        return {
          attributes: [],
        }
      },
    },
  },
  data() {
    return {
      templateAttr: {},
    }
  },
  methods: {
    cancel() {
      this.$emit("cancel")
      this.templateAttr = {}
    },
    changeFile(e, type, id) {
      const self = this
      let reader = new FileReader()
      reader.readAsDataURL(e.target.files[0])
      reader.onload = (res) => {
        let file = document.getElementById(id)
        let fileValue = file.value
        let pos = fileValue.lastIndexOf("\\")
        let fileName = fileValue.substring(pos + 1)
        let fileType = fileName.substring(fileName.lastIndexOf(".") + 1, fileName.length)
        if (type === "picture" && ["jpg", "jpeg", "JPG", "JPEG", "png", "PNG", "gif", "GIF"].indexOf(fileType) === -1) {
          file.value = ""
          self.$Message.error("只支持jpg、jpeg、JPG、JPEG、png、PNG、gif和GIF格式的图片，请重新上传！")
        } else if (type === "video" && ["mp4", "MP4", "webm", "WebM", "ogg", "Ogg"].indexOf(fileType) === -1) {
          file.value = ""
          self.$Message.error("只支持mp4、MP4、webm、WebM、ogg和Ogg格式的视频文件，请重新上传！")
        }
        self.templateAttr[id] = {
          data: res.target.result,
          type: fileType,
        }
        console.log(self.templateAttr)
      }
    },
  },
}
</script>
<style scoped>
.title {
  text-align: center;
}
.a-row {
  margin: 20px 0;
}
</style>
<style>
.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;
}
.vertical-center-modal .ivu-modal {
  top: 0;
}
</style>
